import c0 from './delayed_display_controller';
import c1 from './dromo_controller';
import c2 from './flash_controller';
import c3 from './map_controller';
import c4 from './with_floating/positioner_controller';
import c5 from './with_floating/visibility_controller';
export const definitions = [
	{identifier: 'delayed-display', controllerConstructor: c0},
	{identifier: 'dromo', controllerConstructor: c1},
	{identifier: 'flash', controllerConstructor: c2},
	{identifier: 'map', controllerConstructor: c3},
	{identifier: 'with-floating--positioner', controllerConstructor: c4},
	{identifier: 'with-floating--visibility', controllerConstructor: c5},
];
